<template>
    <Button
        label="Exportar PDF"
        class="p-button-danger mr-2"
        icon="pi pi-download"
        @click="exportarArquivo(1)"
        v-if="mostrarBtnExportar"
        :disabled="desabilitarBtn"
        aria-haspopup="true"
        aria-controls="overlay_menu"
    />
    <Button
        label="Exportar Excel"
        class="p-button-success mr-2"
        icon="pi pi-download"
        @click="exportarArquivo(2)"
        v-if="mostrarBtnExportar"
        :disabled="desabilitarBtn"
        aria-haspopup="true"
        aria-controls="overlay_menu"
    />
</template>

<script>
import services from './service';

export default {
    props: {
        linksPagamentos: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {};
    },

    methods: {
        toggle(event) {
            this.$refs.menu.toggle(event);
        },

        exportarArquivo(id) {
            this.$store.dispatch('addRequest');

            const serviceMethod = id === 1 ? services.exportar() : services.exportarExcel();

            serviceMethod.then((response) => {
                if (response?.success) {
                    let nomeArquivo = `Listagem_links-pagamento_${this.$moment(new Date()).format('DD-MM-YYYY_HH-mm')}.${id === 1 ? 'pdf' : 'xlsx'}`;
                    this.$download(response.data, nomeArquivo);
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Links pagamento',
                        detail: 'Falha ao exportar os links de pagamento',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },

    computed: {
        mostrarBtnExportar() {
            return this.$temAcessoView('CHECKOUTS-PAGAMENTOS-00');
        },

        desabilitarBtn() {
            return !this.linksPagamentos || this.linksPagamentos.length === 0;
        },
    },
};
</script>
